import { useContext, useEffect, useState, useCallback } from "react";
import AuthContext from "../../components/auth-context";
import SGrid from "../../components/sgrid";
import serviceApi from "../../api/service";

function Services() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;
  const [gridKey, setGridKey] = useState(0);

  const dataProvider = useCallback(
    (page: number, pageSize: number) =>
      new serviceApi(context).get(activeFileId!, page, pageSize),
    [context, activeFileId]
  );

  useEffect(() => {
    if (activeFileId) {
      setGridKey((prevKey) => prevKey + 1);
    }
  }, [activeFileId]);

  return (
    <>
      <div className="card dcard overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          key={gridKey}
          dataProvider={dataProvider}
          columns={[
            ["سریال", "link", 0],
            ["تاریخ ثبت", "date", 1],
            ["تاریخ شروع", "date", 3],
            ["تاریخ پایان", "date", 2],
            [" سرویس", "farsi", 4],
            ["وضعیت", "farsi", 5],
          ]}
        />
      </div>
    </>
  );
}

export default Services;
